<template>
    <router-view :name="$route.params.type"/>
</template>

<script>
import {last} from 'lodash';

export default {
    name: 'ServiceFormDispatchView',
    beforeCreate() {
        let type = this.$route.params.type;
        let recordComponents = last(this.$route.matched).components;
        if (!recordComponents.hasOwnProperty(type)) {
            // 这里不太好通知 404 哎，暂时重定向吧
            let url = this.$route.meta.isAdmin
                ? '/service/all/list'
                : '/app/service/list';
            this.$router.replace(url);
        }
    }
};
</script>
